import React from 'react';
import PropTypes from 'prop-types';
import {Route, Redirect} from 'react-router-dom';
import useIdentity from '../../hooks/use-identity';

export default function PrivateRoute(props) {
  const {path, permission, applicationId} = props;
  const {isAuthenticated, login, can, user} = useIdentity();

  React.useEffect(() => {
    if (!isAuthenticated) {
      login({
        appState: {targetUrl: path},
      });
    }
  }, [isAuthenticated]);
  if (isAuthenticated && applicationId && user.applications.indexOf(applicationId) < 0) {
    return <Redirect to="/error/error.not-authorized" />;
  }
  if (isAuthenticated && permission && !can(...permission)) {
    return <Redirect to="/error/error.not-authorized" />;
  }
  if (isAuthenticated) {
    return <Route {...props} />;
  }
  return null;
}

PrivateRoute.propTypes = {
  /** The path to route to */
  path: PropTypes.string.isRequired,
  /** Optionally the permission required to access this route. An array containing `[permission, ability]` as strings. */
  permission: PropTypes.array,
  /** Optionally the application ID that this route belongs to. If passed, then this route will also check that the user has access to this application. */
  applicationId: PropTypes.string,
};
